import 'react-datepicker/dist/react-datepicker.css'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/Button.tsx'
import { IconAddNew } from '../../common/icons.jsx'
import { NewAbscenceModal } from './newabscencemodal/newabscencemodal'

export const PersonalCalendarHeader = ({ tab }) => {
	const { t } = useTranslation()
	const [isOpen, setIsOpen] = useState(false)
	const isPersonalTab = tab === 'personal'

	return (
		<div>
			<div className="d-flex flex-row justify-content-between align-items-center position-relative pb-3">
				<h2 className="viewheading">{t('Events', 'Tapahtumat')}</h2>
				{isPersonalTab && (
					<Button testId="open-abscence-modal" variant="primary" className="py-3" onClick={() => setIsOpen(true)}>
						<IconAddNew /> {t('AddEvent', 'Lisää tapahtuma')}
					</Button>
				)}
			</div>
			{isOpen && <NewAbscenceModal setIsOpen={setIsOpen} event={{}} openedByDateClick={true} />}
		</div>
	)
}
